/* eslint func-names: off */
;(function () {
  if (window.rodeoSubscriptionWidgetInitialized) {
    /* eslint no-console: off */
    console.log('Rodeo subscription widget already initialized')

    return
  }

  window.rodeoSubscriptionWidgetInitialized = true

  document.addEventListener('DOMContentLoaded', () => {
    var lastPurchaseType = ''
    const productForms =
      document.querySelectorAll('form[action^="/cart"]:not([id*="instal"])') ||
      []

    productForms.forEach(productForm => {
      const productFormId = productForm.getAttribute('id')
      const variantIdInput = productForm.querySelector('[name="id"]')
      const sellingPlans =
        productForm.querySelectorAll('[name="selling_plan"]') || []
      const variants = productForm.querySelectorAll('[id^="rodeo-variant--"]')
      const parents = Array.from(variants).map(variant => variant.parentElement)

      const updatePriceDisplay = (wrapper, productPrice) => {
        // const productPriceElement = productForm.parentElement.querySelector(
        //   '[data-product-price]'
        // )
        // const originalPriceElement = productForm.parentElement.querySelector(
        //   '[data-original-price]'
        // )
        const productPriceElement = document.querySelector('[data-product-price-main]') ||
                                    productForm.parentElement.querySelector('[data-product-price]')
        const originalPriceElement = document.querySelector('[data-original-price-main]') ||
                                    productForm.parentElement.querySelector('[data-original-price]')

        const comparePriceElement = document.querySelector('[data-compare-price-main]') ||
                                    productForm.parentElement.querySelector( '[data-compare-price]')

        const sellingPlans = wrapper.querySelector('[name="selling_plan"]')
        const sellingPlan = sellingPlans.querySelector('option:checked')


        document.querySelectorAll('.afterpay_wrap.main').forEach(n=>{n.style.display = "none"})


        const discountPercentage = sellingPlan.dataset.discount
        const originalPrice = wrapper.dataset.price
        const discountedPrice = sellingPlan.dataset.price

        const discountElement = wrapper.querySelector('.rodeo-variant-discount')

        // not displayed for subscription-only (e.g. 3-month packs)
        if (discountElement) {
          const discountPercentElement = discountElement.querySelector(
            '.rodeo-variant-discount-percentage'
          )
          const discountPriceElement = discountElement.querySelector(
            '.rodeo-variant-discount-price'
          )

          if (discountPercentage !== '0%') {
            discountPercentElement.textContent = discountPercentage
            discountPriceElement.textContent = discountedPrice
            discountElement.style.display = ''
          } else {
            discountElement.style.display = 'none'
          }
        } 
        // console.log("goodbye")
        // console.log("discountedPrice",discountedPrice)
        // const discountPriceSpan = document.querySelector('span#discount-price');
        // const mainPriceSpan = document.querySelector('span#main-price');
        // console.log(discountPrice);
        // discountPriceSpan.style.display = 'block'
        // discountPriceSpan.innerText = originalPrice
        // mainPriceSpan.innerText

        productPriceElement.textContent = discountedPrice

        if (
          discountedPrice === originalPrice ||
          (comparePriceElement && comparePriceElement.textContent.trim() !== '')
        ) {
          originalPriceElement.textContent = ''
          originalPriceElement.style.display = 'none'
        } else {
          originalPriceElement.textContent = originalPrice.split(".")[0]
          originalPriceElement.style.display = ''
        }
      }
      const resetPriceDisplay = wrapper => {
        // var productPriceElement = productForm.parentElement.querySelector(
        //   '[data-product-price]'
        // )
        // var originalPriceElement = productForm.parentElement.querySelector(
        //   '[data-original-price]'
        // )
        const productPriceElement = document.querySelector('[data-product-price-main]') ||
                          productForm.parentElement.querySelector('[data-product-price]')
        const originalPriceElement = document.querySelector('[data-original-price-main]') ||
                          productForm.parentElement.querySelector('[data-original-price]')

        // console.log("originalPriceElement",originalPriceElement)
        // console.log("productPriceElement",productPriceElement)

        // document.querySelector('.afterpay_wrap.main').style.display = "block";
        document.querySelectorAll('.afterpay_wrap.main').forEach(n=>{n.style.display = "block"})

        if (wrapper) {
          const originalPrice = wrapper.dataset.price
          // console.log("originalPrice",originalPrice)
          productPriceElement.textContent = originalPrice.split(".")[0]
          originalPriceElement.textContent = ''
        }

        originalPriceElement.style.display = 'none'
      }

      sellingPlans.forEach(el => el.setAttribute('form', productFormId))

      variants.forEach(wrapper => {
        const purchaseTypes = wrapper.querySelectorAll(
          'input[name="purchase_type"]'
        )
        purchaseTypes.forEach(purchaseType => {
          purchaseType.addEventListener('click', e => {
            // switch toggle
            productForm.querySelectorAll('.rc_block__type').forEach(el => {
              // override theme js
              el.style.display = ''
              el.classList.remove('rc_block__type--active')
            })

            const purchaseType = e.target
            const sellingPlans = wrapper.querySelector('[name="selling_plan"]')
            const block = purchaseType.closest('.rc_block__type')

            // handle subscription option not output
            block && block.classList.add('rc_block__type--active')

            lastPurchaseType = purchaseType.value

            if (lastPurchaseType === 'autodeliver') {
              sellingPlans.disabled = false
              console.log("=>updatePriceDisplay")
              console.log(wrapper)
              updatePriceDisplay(wrapper)
            } else {
              sellingPlans.disabled = true
              console.log("=>resetPriceDisplay")
              console.log(wrapper)
              resetPriceDisplay(wrapper)
            }
          })
        })
      })

      productForm.addEventListener('change', e => {
        const selectedVariantId = variantIdInput.value

        variants.forEach((wrapper, index) => {
          const { variantId } = wrapper.dataset

          if (selectedVariantId !== variantId) {
            wrapper.style.display = 'none'
            wrapper.classList.remove('rodeo-variant--active')
            wrapper.remove()
          } else {
            wrapper.style.removeProperty('display')
            wrapper.classList.add('rodeo-variant--active')
            parents[index].appendChild(wrapper)

            const purchaseType = wrapper.querySelector(
              `input[name="purchase_type"][value="${lastPurchaseType}"]`
            )

            // handle subscription option not output
            purchaseType && purchaseType.click()
          }
        })

        const activeWrapper = productForm.querySelector(
          '.rodeo-variant--active'
        )

        // no wrapper for caddy because theme sets variant ID input to empty
        // and we can't toggle the wrapper based on that.
        if (activeWrapper) {
          var purchaseType =
            activeWrapper.querySelector(
              'input[name="purchase_type"]:checked'
            ) || activeWrapper.querySelector('input[name="purchase_type"]')

          if (purchaseType.value === 'autodeliver') {
            updatePriceDisplay(activeWrapper)
          } else {
            resetPriceDisplay(activeWrapper)
          }
        } else {
          resetPriceDisplay()
        }
      })

      variants.forEach(wrapper => {
        if (wrapper.className.indexOf('rodeo-variant--active') === -1) {
          wrapper.remove()
        } else if (wrapper.dataset.subscriptionOnly === 'true') {
          const purchaseType = wrapper.querySelector(
            'input[name="purchase_type"].rc_radio__autodeliver'
          )
          // trigger theme js things
          purchaseType.click()

          setTimeout(() => {
            // again for good measure
            purchaseType.click()
          }, 500)
        }
      })
    })
  })
})()
